import React from "react";
import DragAndDropImages from "../../../../atoms/Forms/DragAndDropImages";

import styles from "./MainApp.organisms.Product.Details.FormImageProduct.module.scss";
import i18n from "i18n";

export class FormEditProduct extends React.Component {
  render() {
    const {product, handleChange, handleDelete, onHandleStarClick, selectedStarIndex, error } = this.props;

    return (
      <div
        className={`${styles["form-edit-image-container"]} ${!product.enabled ? styles["disabled"] : ""}`}
        data-automation-id="form-edit-image-container"
      >
        <div className={styles["form-edit-image-title"]}>
          {i18n.t("step.image")}
        </div>
        <DragAndDropImages
          name="image"
          handleChange={handleChange}
          handleDelete={handleDelete}
          files={product.item_files}
          error={error.image}
          onHandleStarClick={onHandleStarClick}
          selectedStarIndex={selectedStarIndex}
          msgInfoFiles={i18n.t("resource.selected")}
          showSelectorFiles={true}
        />
        {!product.enabled && <div className={styles["form-edit-image-overlay"]}></div>}
      </div>
    );
  }
}

export default FormEditProduct;
